import { useEffect, useState } from "react";
import { CheckPicker, Loader, SelectPicker, Toggle, Tooltip, Whisper } from "rsuite";
import { DataTable } from "primereact/datatable";
import {
  getBoardCostTrendReportDataForExcel,
  useBusinessCostFilter,
} from "../../../react-query/hooks/HBusinessCostSetting";
import moment from "moment";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { appInsights } from "../../../router/router";
import { useBusinessCostTrendData } from "../../../react-query/hooks/HBusinessCostTrend";
import {
  BTrendTableData,
  TimeFrame,
} from "../../../services/interfaces/IBusinessCostTrend";
import { Column } from "primereact/column";
import {
  formatNumberwithCommas,
  numberFormatter,
} from "../../../utils/formatter";
import { BusinessCostCompChart } from "../../../components/bc-trend-chart/BusinessCostCompChart";
import BusinessCostBarChart from "../../../components/bc-trend-chart/BusinessCostBarChart";
import BcChartLegends from "../../../assets/bc-trend-chart-legends-updated.svg";
import useResponsiveWidth from "../../../react-query/hooks/useResponsiveWidth";
import {
  convertDateToFullDate,
  convertDateToMonthYear,
} from "../../../utils/helpers/mapModulesToIcon";
import JSZip from "jszip";
import { sortCommodityFirst, getDefaultCommodity } from "../../../utils/helpers/commodityOrder";
import { locationCodes } from "../../../utils/constants";
import ProductInfoIcon from "../../../assets/info-circle-grey.svg";


const BusinessCostTrend = () => {
  const width = useResponsiveWidth();
  const [commodity, setCommodity] = useState<string | null>(null);
  // Applied district selection that drives the API. Empty array means "All" (default page load).
  const [district, setDistrict] = useState<string[]>([]);
  // Live selection inside the picker; applied to `district` only when the dropdown closes.
  const [pendingDistrict, setPendingDistrict] = useState<string[]>([]);
  const [baseSKU, setBaseSKU] = useState<null | string>(null);

  const { fetchFilters: filters, isLoading } = useBusinessCostFilter(
    localStorage.getItem("userEmail"),
    commodity,
    baseSKU
  );

  const [timeFrame, setTimeFrame] = useState<TimeFrame>(TimeFrame.MONTH);
  const [isChecked, setIsChecked] = useState(false);
  const [treeDistrict, SetTreeDistrict] = useState<string[]>([]);

  // Strip the " - Total" suffix used for parent/tree districts before sending to the API
  const stripTotal = (value: string) =>
    value.indexOf(" - Total") !== -1
      ? value.split(" - Total")[0].trim()
      : value;

  // Districts to send to the API (empty selection defaults to "All"; strips " - Total" suffixes)
  const apiDistricts =
    district.length > 0 ? district.map(stripTotal) : ["All"];

  // Label shown in chart/table headers for the selected districts
  const districtLabel =
    district.length > 0 ? district.map(stripTotal).join(", ") : "All";

  const { data: trendData, isLoading: dataLoading } = useBusinessCostTrendData(
    commodity,
    apiDistricts,
    timeFrame,
    localStorage.getItem("userEmail"),
    baseSKU
  );

  const getParentDistrictNames = (data: any) => {
    const grouped: any = [];

    if (data) {
      data?.forEach((item: any) => {
        if (item.district.indexOf(" - ") !== -1) {
          const groupKey = item.district.split(" - ")[0].trim();
          grouped.push(groupKey);
        }
      });
      SetTreeDistrict(grouped);
    }
  };

  useEffect(() => {
    if (
      filters &&
      filters?.commodity &&
      filters?.commodity?.length !== 0
      // &&
      // commodity === null
    ) {
      setCommodity(commodity || getDefaultCommodity(filters?.commodity) || null);
      setBaseSKU(
        baseSKU ||
        (filters?.baseSKU && filters?.baseSKU.length
          ? filters.baseSKU[0]?.base_sku
          : null)
      );
    }
  }, [filters, filters.baseSKU]);

  useEffect(() => {
    getParentDistrictNames(
      filters?.districts && filters?.districts.length
        ? filters?.districts
        : null
    );
  }, [filters.districts]);

  useEffect(() => {
    setBaseSKU(null);
  }, [commodity]);

  const toggleDuration = () => {
    if (timeFrame === "monthly") {
      setTimeFrame(TimeFrame.WEEK);
      setIsChecked(true);
    } else {
      setTimeFrame(TimeFrame.MONTH);
      setIsChecked(false);
    }
  };

  // const downloadExcelForTrends = async () => {
  //   const excelData = await getBoardCostTrendReportDataForExcel(
  //     localStorage.getItem("userEmail"),
  //     commodity,
  //     isChecked ? "weekly" : "monthly",
  //     district
  //   );
  //   let newdata = excelData?.data?.data?.data;
  //   if (newdata) {
  //     let zip = new JSZip();
  //     const filePromises = Object?.keys(newdata)?.map(
  //       async (item: any, index, arr) => {
  //         const workbook = new ExcelJS.Workbook();
  //         const worksheet = workbook.addWorksheet(`Board Cost`);

  //         const Headers = [
  //           { header: "Commodity", key: "commodity", width: 15 },
  //           { header: "District", key: "district", width: 15 },
  //           {
  //             header: "Month",
  //             key: "date",
  //             style: { numFmt: isChecked ? "yyyy-mm-dd" : "mmm-yyyy" },
  //             width: 5,
  //           },
  //           {
  //             header: "PO Cost ($/cft)",
  //             key: "po_cost",
  //             width: 15,
  //             style: { numFmt: "$#,##0.00" },
  //           },
  //           {
  //             header: "Board Cost ($/cft)",
  //             key: "business_cost",
  //             width: 15,
  //             style: { numFmt: "$#,##0.00" },
  //           },
  //           {
  //             header: "Sales Price ($/cft)",
  //             key: "sell_price",
  //             width: 15,
  //             style: { numFmt: "$#,##0.00" },
  //           },
  //           { header: "Sales Volume (lbs)", key: "volume", width: 15 },
  //         ];
  //         worksheet.columns = Headers;
  //         const formattedData = newdata[item].map((ele: any) => ({
  //           commodity: commodity,
  //           district: ele?.district,
  //           date: isChecked ? new Date(ele.date) : new Date(ele.date),
  //           po_cost: ele?.po_cost,
  //           business_cost: ele?.business_cost,
  //           sell_price: ele?.sell_price,
  //           volume: ele?.volume,
  //         }));
  //         worksheet.addRows(formattedData);
  //         // Apply styling to all data rows
  //         worksheet.eachRow({ includeEmpty: true }, (row, rowNumber) => {
  //           row.eachCell({ includeEmpty: true }, (cell) => {
  //             cell.alignment = {
  //               // wrapText: true,
  //               vertical: "middle",
  //               horizontal: rowNumber <= 1 ? "center" : "left",
  //             };
  //             cell.border = {
  //               top: { style: "thin" },
  //               left: { style: "thin" },
  //               bottom: { style: "thin" },
  //               right: { style: "thin" },
  //             };
  //             if (rowNumber <= 1) {
  //               cell.font = { bold: true };
  //               row.height = 30;
  //             }
  //           });
  //         });

  //         worksheet.columns.forEach((column: any) => {
  //           let maxLength = 0;
  //           column.eachCell({ includeEmpty: true }, (cell: any) => {
  //             if (cell.value) {
  //               const cellValue = cell.value.toString();
  //               maxLength = Math.max(maxLength, cellValue.length);
  //             }
  //           });
  //           column.width = maxLength + 2; // Add some padding to the width
  //         });

  //         const buffer = await workbook.xlsx.writeBuffer();
  //         const excelBlob1 = new Blob([buffer], {
  //           type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //         });

  //         zip.file(
  //           `${locationCodes[item]} Board Cost_${commodity}.xlsx`,
  //           excelBlob1
  //         );
  //       }
  //     );
  //     // Wait for all promises to complete before generating the zip
  //     await Promise.all(filePromises);
  //     // Generate and save the zip file
  //     const zipBlob = await zip.generateAsync({ type: "blob" });
  //     saveAs(
  //       zipBlob,
  //       `Board Cost Trend ${moment(new Date()).format("MM-DD-YYYY")}.zip`
  //     );
  //     appInsights.trackEvent({
  //       name: "Board Cost Trnd: Board Cost Trend Excel",
  //       properties: {
  //         description: `${localStorage.getItem(
  //           "userEmail"
  //         )} has downloaded "BoardCostTrend.zip" File`,
  //       },
  //     });
  //   }
  // };

  const downloadExcelForTrends = async () => {
    const excelData = await getBoardCostTrendReportDataForExcel(
      localStorage.getItem("userEmail"),
      commodity,
      isChecked ? "weekly" : "monthly",
      apiDistricts,
      baseSKU
    );
    let newdata = excelData?.data?.data?.data;

    if (newdata) {
      const dataKeys = Object.keys(newdata);

      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet(`Board Cost`);

      const Headers = [
        { header: "Commodity", key: "commodity", width: 15 },
        { header: "District", key: "district", width: 15 },
        {
          header: "Month",
          key: "date",
          style: { numFmt: isChecked ? "yyyy-mm-dd" : "mmm-yyyy" },
          width: 5,
        },
        {
          header: "PO Cost ($/cft)",
          key: "po_cost",
          width: 15,
          style: { numFmt: "$#,##0.00" },
        },
        {
          header: "Board Cost ($/cft)",
          key: "business_cost",
          width: 15,
          style: { numFmt: "$#,##0.00" },
        },
        {
          header: "Sales Price ($/cft)",
          key: "sell_price",
          width: 15,
          style: { numFmt: "$#,##0.00" },
        },
        { header: "Sales Volume (lbs)", key: "volume", width: 15 },
      ];

      worksheet.columns = Headers;

      // Combine every selected district's rows into the same worksheet;
      // the District column differentiates the rows (matches the pattern
      // used for single-sheet, multi-row exports elsewhere in the app).
      const formattedData = dataKeys.flatMap((item) =>
        (newdata[item] ?? []).map((ele: any) => ({
          commodity: commodity,
          district: ele?.district,
          date: new Date(ele.date),
          po_cost: ele?.po_cost,
          business_cost: ele?.business_cost,
          sell_price: ele?.sell_price,
          volume: ele?.volume,
        }))
      );

      worksheet.addRows(formattedData);

      // Apply styling to all data rows
      worksheet.eachRow({ includeEmpty: true }, (row, rowNumber) => {
        row.eachCell({ includeEmpty: true }, (cell) => {
          cell.alignment = {
            vertical: "middle",
            horizontal: rowNumber <= 1 ? "center" : "left",
          };
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
          if (rowNumber <= 1) {
            cell.font = { bold: true };
            row.height = 30;
          }
        });
      });

      worksheet.columns.forEach((column: any) => {
        let maxLength = 0;
        column.eachCell({ includeEmpty: true }, (cell: any) => {
          if (cell.value) {
            const cellValue = cell.value.toString();
            maxLength = Math.max(maxLength, cellValue.length);
          }
        });
        column.width = maxLength + 2;
      });

      const buffer = await workbook.xlsx.writeBuffer();
      const fileNameSuffix = district.length > 0 ? districtLabel : "All";
      const fileName = `Board Cost Trend_${commodity}_${fileNameSuffix}_${moment(
        new Date()
      ).format("MM-DD-YYYY")}.xlsx`;

      saveAs(
        new Blob([buffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        }),
        fileName
      );

      appInsights.trackEvent({
        name: "Board Cost Trend: Board Cost Trend Excel",
        properties: {
          description: `${localStorage.getItem(
            "userEmail"
          )} has downloaded "${fileName}" File`,
        },
      });
    }
  };

  return (
    <>
      {isLoading || dataLoading ? (
        <Loader
          backdrop
          content="Loading..."
          size="md"
          vertical
          className="text-black font-bold"
          style={{ opacity: 0.6 }}
        />
      ) : (
        <div className="flex flex-col justify-stretch items-stretch h-full business-cost-settings">
          <div className="grow shrink-0 basis-[15%] ps-[3%] pr-[5%] pt-[1.6%] flex flex-col flex-nowrap justify-start items-start gap-0 shadow-normal relative">
            <div className="flex justify-between items-center w-full">
              <div className="font-normal text-[2vw]">Board Cost Trend</div>
              <div className="flex justify-start items-center gap-8">
                <div className="flex flex-col justify-start items-start">
                  <label className="font-bold text-[0.8vw]">Commodity</label>
                  <SelectPicker
                    data={sortCommodityFirst(filters.commodity)}
                    value={commodity ?? getDefaultCommodity(filters?.commodity)}
                    labelKey="commodity"
                    valueKey="commodity"
                    style={{ width: width }}
                    onChange={(value: string | null) => {
                      setCommodity(value);
                      setDistrict([]);
                      setPendingDistrict([]);
                    }}
                    placeholder="All"
                    cleanable={false}
                  ></SelectPicker>
                </div>

                <div className="flex flex-col justify-start items-start">
                  <label className="font-bold text-[0.8vw]">District</label>
                  <CheckPicker
                    data={
                      filters.districts
                        ? filters.districts.map((ele) =>
                          treeDistrict.indexOf(ele.district) !== -1
                            ? { district: `${ele.district} - Total` }
                            : ele
                        )
                        : []
                    }
                    value={pendingDistrict}
                    labelKey="district"
                    valueKey="district"
                    onChange={(value: string[]) => {
                      const next = value ?? [];
                      setPendingDistrict(next);
                      // Removing all checkboxes reverts to the default "All"
                      if (next.length === 0) {
                        setDistrict([]);
                      }
                    }}
                    onClose={() => {
                      // Fire the API only once the dropdown closes with the final selection
                      setDistrict(pendingDistrict);
                    }}
                    placeholder="All"
                    cleanable={false}
                    sticky
                    style={{ width: width }}
                  ></CheckPicker>
                </div>
                <div className="flex flex-col justify-start items-start">
                  <label className="font-bold text-[0.8vw]">Base SKU</label>
                  <SelectPicker
                    data={filters.baseSKU}
                    value={baseSKU}
                    labelKey="base_sku"
                    valueKey="base_sku"
                    style={{ width: width }}
                    onChange={(value: string | null) => {
                      setBaseSKU(value);
                    }}
                    placeholder="All"
                    cleanable={false}
                  ></SelectPicker>
                </div>
              </div>
            </div>
            <span className="font-bold text-fs16 text-[#858585]">
              Negotiation {commodity === "Copper Wire" ? "Week" : "Month"}
              :&nbsp;
              <span className="font-bold underline text-deloitteGreen">
                {Object.keys(filters).length > 0
                  ? commodity === "Copper Wire"
                    ? convertDateToFullDate(filters?.date[0].month_year)
                    : convertDateToMonthYear(filters?.date[0].month_year)
                  : ""}
              </span>
            </span>
          </div>

          <div className="bg-[#F1F1F1] grow shrink p-[1%] pr-[5%] flex flex-col flex-nowrap justify-start items-start gap-2 h-full w-full">
            <div className="shadow-module-card bg-white border border-[#bebebe] rounded-md w-full h-[50vh] grow flex flex-col flex-nowrap">
              <div className="w-full h-[90%] grow flex flex-col">
                <div className="w-full flex justify-between font-bold p-pd13 text-fs16 h-[11%]">
                  <span>
                    Sales Price, Gross PO Cost and Board Cost in{" "}
                    <span className="text-deloitteGreen">{districtLabel}</span>
                  </span>
                  <div
                    onClick={(e) => {
                      e.stopPropagation();
                      downloadExcelForTrends();
                    }}
                    className="flex w-[50%] justify-end gap-5"
                  >
                    <div
                      className={
                        "bottom-2 text-white bold text-[0.8vw] right-[5.3vh] bg-[#86BC25] p-[0.4vw] rounded-md cursor-pointer flex items-center"
                      }
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="1vw"
                        height="1vw"
                        viewBox="0 0 12 16"
                        fill="none"
                      >
                        <path
                          d="M14.6668 5.33464V9.20797C14.2602 8.97464 13.8135 8.81464 13.3335 8.72797V5.33464H2.66683V12.0013H8.72683C8.6935 12.2213 8.66683 12.4413 8.66683 12.668C8.66683 12.8946 8.6935 13.1146 8.72683 13.3346H2.66683C1.9335 13.3346 1.3335 12.7413 1.3335 12.0013V4.0013C1.3335 3.2613 1.92683 2.66797 2.66683 2.66797H6.66683L8.00016 4.0013H13.3335C14.0668 4.0013 14.6668 4.59464 14.6668 5.33464ZM13.3335 10.668H12.0002V13.3346H10.6668L12.6668 15.3346L14.6668 13.3346H13.3335V10.668Z"
                          fill="white"
                        />
                      </svg>
                      <span className="ml-[3px]">Download</span>
                    </div>
                  </div>
                </div>

                <div className="w-full flex flex-row flex-nowrap justify-between items-center h-[8%] px-[1vh]">
                  <div className="w-[45%] flex flex-row flex-nowrap">
                    <img
                      src={BcChartLegends}
                      alt="Chart Legends"
                      width={"100%"}
                    />
                  </div>
                  <div className="w-full flex flex-nowrap justify-end items-center gap-2">
                    <span
                      className={`text-fs12 ${isChecked === false ? "font-bold" : ""
                        }`}
                    >
                      Monthly
                    </span>
                    <span>
                      <Toggle
                        checked={isChecked}
                        color="green"
                        onChange={toggleDuration}
                      />
                    </span>
                    <span
                      className={`text-fs12 ${isChecked === true ? "font-bold" : ""
                        }`}
                    >
                      Weekly
                    </span>
                  </div>
                </div>

                <div className="w-full flex flex-row flex-nowrap h-[50%]">
                  {trendData?.chart_data && (
                    <BusinessCostCompChart
                      data={trendData?.chart_data ?? []}
                      id={"1"}
                      timeFrame={timeFrame}
                      commodity={commodity}
                      baseSKU={baseSKU}
                    />
                  )}
                </div>

                <div className="h-px bg-[#bebebe] ml-[5rem] mr-[0.75rem] opacity-30" />

                <div className="w-full flex flex-row flex-nowrap px-[1xh] h-[31%]">
                  {trendData?.chart_data && (
                    <BusinessCostBarChart
                      data={trendData?.chart_data ?? []}
                      timeFrame={timeFrame}
                      commodity={commodity}
                    />
                  )}
                </div>
              </div>
              <div className="w-full h-[6%] px-[1vw] py-[0.5vh] text-[1.6vh] text-[#858585] list-disc">
                * Sales Volume, Board Cost and Sell Price is calculated at the
                district level for districts divided into sub-regions
              </div>
            </div>

            <span className="w-full bg-white font-bold p-pd13 shadow-module-card border border-[#bebebe] text-fs16 rounded-md">
              Board Cost Estimate in{" "}
              <span className="text-deloitteGreen">{districtLabel}</span>
            </span>

            <div className="w-full business-cost-trend-table">
              <DataTable
                className="h-full w-full"
                value={trendData?.kpi?.table_data ?? []}
                stripedRows
                showGridlines
              >
                <Column
                  field="agent_pricing"
                  header="Market Pricing"
                  body={(rowdata: BTrendTableData, body) => {
                    return rowdata.agent_pricing ? (
                      <span>
                        {commodity?.toLowerCase() === "copper wire" &&
                          body.rowIndex === 0
                          ? `$${formatNumberwithCommas(
                            rowdata.agent_pricing,
                            true
                          )}`
                          : numberFormatter(
                            rowdata.agent_pricing,
                            body.rowIndex === 0 ? 2 : 0,
                            body.rowIndex === 0 ? "$" : ""
                          )}
                        {body.rowIndex === 1 ? "%" : ""}
                      </span>
                    ) : (
                      <span>{body.rowIndex === 0 ? "" : "-"}</span>
                    );
                  }}
                ></Column>
                <Column
                  field="vendor_quotes"
                  header="Supplier Quotes"
                  body={(rowdata: BTrendTableData, body) => {
                    return (
                      <span>
                        {commodity?.toLowerCase() === "copper wire" &&
                          body.rowIndex === 0
                          ? `$${formatNumberwithCommas(
                            rowdata.vendor_quotes,
                            true
                          )}`
                          : numberFormatter(
                            rowdata.vendor_quotes,
                            body.rowIndex === 0 ? 2 : 0,
                            body.rowIndex === 0 ? "$" : ""
                          )}
                        {body.rowIndex === 1 ? "%" : ""}
                      </span>
                    );
                  }}
                ></Column>
                <Column
                  field="target_cost"
                  header="Index-Implied Cost"
                  body={(rowdata: BTrendTableData, body) => {
                    return (
                      <span>
                        {commodity?.toLowerCase() === "copper wire" &&
                          body.rowIndex === 0
                          ? `$${formatNumberwithCommas(
                            rowdata.target_cost,
                            true
                          )}`
                          : numberFormatter(
                            rowdata.target_cost,
                            body.rowIndex === 0 ? 2 : 0,
                            body.rowIndex === 0 ? "$" : ""
                          )}
                        {body.rowIndex === 1 ? "%" : ""}
                      </span>
                    );
                  }}
                ></Column>
                {commodity !== "Copper Wire" && (
                  <Column
                    field="project_pricing"
                    header="Project Pricing"
                    body={(rowdata: BTrendTableData, body) => {
                      return (
                        <div className="flex gap-1 items-center">
                          {numberFormatter(
                            rowdata.project_pricing,
                            body.rowIndex === 0 ? 2 : 0,
                            body.rowIndex === 0 ? "$" : ""
                          )}
                          {body.rowIndex === 1 ? "%" : ""}

                          {body.rowIndex === 0 && rowdata.proxy_flag === 1 && (
                            <Whisper
                              speaker={
                                <Tooltip placement="auto">
                                  Project pricing at district level is used as plant group level project pricing was not available
                                </Tooltip>
                              }
                            >
                              <img
                                src={ProductInfoIcon}
                                alt="info"
                                className="w-[1.5vh] h-[1.5vh] cursor-pointer"
                              ></img>
                            </Whisper>
                          )}
                        </div>
                      );
                    }}
                  ></Column>
                )}
              </DataTable>
            </div>

            <span className="w-full bg-white font-bold p-pd13 shadow-module-card border border-[#bebebe] text-fs16 flex justify-between items-center rounded-md">
              <span className="flex gap-2 items-center">

                Recommended Board Cost

                {trendData?.kpi?.table_data?.[0]?.bc_under_quote_flag === 1 && <Whisper
                  placement="top"
                  speaker={
                    <Tooltip placement="top">
                      Board cost recommended at PO cost + 1.5%, since other factor impacts are low and the weighted-average recommendation would otherwise fall below PO cost
                    </Tooltip>
                  }
                >
                  <img
                    src={ProductInfoIcon}
                    alt="info"
                    className="w-[1.5vh] h-[1.5vh] cursor-pointer"
                  ></img>
                </Whisper>}
              </span>
              <span className="text-fs32 font-normal">
                {typeof trendData?.kpi?.recommended_business_cost === "number" &&
                !Number.isNaN(trendData.kpi.recommended_business_cost)
                  ? `$${trendData.kpi.recommended_business_cost.toFixed(2)}`
                  : "-"}
              </span>
            </span>
          </div>
        </div>
      )}
    </>
  );
};

export default BusinessCostTrend;
